import {useState,useEffect} from "react";
import Chart from "react-apexcharts";
import schedulePayService from '../../services/SchedulePayService';

const formatCurrency = (value) => {
    return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    }).format(value);
};

export default function CardV2({ year }) {
    const [totalsInvoice, setTotalsInvoice] = useState({
        withInvoice: 0,
        withOutInvoice: 0
    });

    useEffect(() => {
        schedulePayService.getTotalsByYear(year)
            .then(res => {
                setTotalsInvoice({
                    withInvoice: Number(res.data.withInvoice),
                    withOutInvoice: Number(res.data.withOutInvoice)
                });
            })
        .catch(console.error);
    }, [year]);


  	return (
        <div className="col-md-6 col-xxl-4 mb-6">
            <div className="card h-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title m-0 me-2">Sezione Due</h5>
                </div>
    <Chart
      type="donut"
      series={[
        totalsInvoice.withInvoice,
        totalsInvoice.withOutInvoice
      ]}
      options={{
        labels: ["Fatture emesse", "Fatture da emettere"],
        legend: { position: "bottom" },
        tooltip: {
          y: {
            formatter: v => formatCurrency(v)
          }
        },
        dataLabels: {
          //formatter: v => formatCurrency(v)
        }
      }}
      height={320}
    />

  <Chart
    type="bar"
    height={300}
    series={[
      { name: "Entrate", data: [5000, 6000, 7000] },
      { name: "Uscite", data: [3000, 3500, 4000] }
    ]}
    options={{
      chart: { stacked: true },
      xaxis: {
        categories: ["2022", "2023", "2024"]
      }
    }}
  />
            </div>
        </div>
	);
}